import { useState } from "react";
import { useTranslation } from "react-i18next";

import "../../assets/css/style.css";

import rate_ex_diss from "../../assets/Images/emotion/extremelly_dissatisfied.svg";
import rate_diss from "../../assets/Images/emotion/dissatisfied.svg";
import rate_neutr from "../../assets/Images/emotion/neutral.svg";
import rate_sat from "../../assets/Images/emotion/satisfied.svg";
import rate__ex_sat from "../../assets/Images/emotion/extremelly_satisfied.svg";
import { useFintechLayouts, useFeedbackMutation } from "../../services/AsaApiServices";
import { AnalyticsService, AnalyticsAction, AnalyticsFeature } from "../../services/AnalyticsService";
import "./SubscriptionManagement.css"; // Import your CSS file for animations
import Lottie from "react-lottie";
import * as successData from "../../assets/Images/animation/success_animation.json";
import "./SubscriptionManagement.css"; // Import your CSS file for animations
import InlineRateSelector ,{RateValue} from "./InlineRateSelector"
interface IPropsRateSelector {
  rate: number;
  setRate(val: number): void;
}
interface IIRateItem {
  rateVal: number;
  text: string;
  imgsrc: string;
}
interface IPropsSubscriptionFeedback {
  onSubmitFeedback(): void;
  subScriptionPlanCode: number | undefined;
}
/*
const RateSelector = ({ rate, setRate }: IPropsRateSelector) => {
  const rateitems: IIRateItem[] = [
    { rateVal: 1, text: "1", imgsrc: rate_ex_diss },
    { rateVal: 2, text: "2", imgsrc: rate_diss },
    { rateVal: 3, text: "3", imgsrc: rate_neutr },
    { rateVal: 4, text: "4", imgsrc: rate_sat },
    { rateVal: 5, text: "5", imgsrc: rate__ex_sat },
  ];

  const renderRateItem = (item: IIRateItem, idx: number, isSelected: boolean) => {
    return (
      <div key={idx}>
        <img
          src={item.imgsrc}
          alt={item.text}
          className={"mx-2 subscription-rate-icon" + (isSelected ? " subscription-rate-icon-inverted" : "")}
          onClick={(e) => setRate(item.rateVal)}
        />
      </div>
    );
  };
  return (
    <div className="flex flex-row">
      {rateitems.map((item, idx) => renderRateItem(item, idx, rate === item.rateVal))}
    </div>
  );
};
*/
const SubscriptionFeedbackSubmitted = ({ successMessage, feedbackMessage }: { successMessage: string; feedbackMessage: string }) => (
  <div className="dark:text-[#D8D8D8]  text-[#4E4E4E] dark:bg-[#121212] bg-[#EBECF0] subscription-feedback-container flex flex-col">
    <div className="flex flex-row items-center">
      <Lottie
        options={{
          loop: false,
          autoplay: true,
          animationData: successData,
          rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
          },
        }}
        height={350}
        width={350}
      />
    </div>
    <div className=" text-center font-poppins text-xl font-bold leading-6 w-[234px] flex flex-col mt-6 items-center">
      <div>
        <p>{successMessage}</p>
      </div>
      <div className="mt-6">
        <p>{feedbackMessage}</p>
      </div>
    </div>
  </div>
);
const SubscriptionFeedback = ({ onSubmitFeedback, subScriptionPlanCode }: IPropsSubscriptionFeedback) => {
  const { t } = useTranslation();
  const [rate, setRate] = useState<RateValue | -1>(-1);
  const [feedback, setFeedback] = useState("");
  const isDisabledFeedback = rate < 0 || feedback.length === 0;
  const feedbackMutation = useFeedbackMutation();
  const [isFeedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const fintechLaoyut = useFintechLayouts();

  const handleSubmit = async () => {
    if (isDisabledFeedback) return;
    try {
      await feedbackMutation.mutateAsync({
        rate: rate,
        msg: feedback,
        subScriptionPlanCode: subScriptionPlanCode,
      });
      AnalyticsService.track("Feedback Submitted", AnalyticsAction.Click, AnalyticsFeature.Payment);
      setFeedbackSubmitted(true);
      setTimeout(() => {
        setFeedbackSubmitted(false);
        onSubmitFeedback();
      }, 5000);
    } catch (err) {
      AnalyticsService.track("Feedback Submit Error", AnalyticsAction.API_Result, AnalyticsFeature.Payment);
      console.error(err);
      // showSubscriptionToast(t("failedToSubmitFeedback"), true);
    }
  };

  return (
    <>
      <div className="dark:text-[#D8D8D8]  text-[#4E4E4E] dark:bg-[#121212] bg-[#EBECF0] flex flex-col items-center">
        {!isFeedbackSubmitted && (
          <>
            <div className="flex flex-col subscription-feedback-head mt-10">
              {t("rateExperience", { appName: fintechLaoyut?.appName })}
            </div>
            <div className="p-2 rounded-lg flex flex-row mt-4 bg-[#EBECF0] dark:bg-[#121212]">
              <div className="flex flex-row mx-2 items-center">{t("bad")}</div>
              {/*<RateSelector rate={rate} setRate={setRate}></RateSelector>*/}
              <InlineRateSelector value={rate} 
                onChange={(val) => setRate(val)}
                size={24}
               />
              <div className="flex flex-row mx-2 items-center">{t("good")}</div>
            </div>
            <div className="subscription-feedback-text mt-8 text-base bg-[#D9D9D9] dark:bg-[#282828]">
              <textarea
                className="subscription-feedback-input text-base bg-[#D9D9D9] dark:bg-[#282828]"
                placeholder={t("shareThoughts")}
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
              ></textarea>
            </div>
            <div
              className={
                "mt-4 subscription-btn-submitfeedback" +
                (isDisabledFeedback ? " subscription-btn-submitfeedback-disabled" : "")
              }
              onClick={() => handleSubmit()}
              style={fintechLaoyut?.buttonStyle}
            >
              {t("submitFeedback")}
            </div>
          </>
        )}
        {isFeedbackSubmitted && (
          <SubscriptionFeedbackSubmitted
            successMessage={t("thankYou")}
            feedbackMessage={t("feedbackRecorded")}
          />
        )}
      </div>
    </>
  );
};

export default SubscriptionFeedback;